import cx from "classnames";
import Magnify24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Magnify24PxOutlined";
import styles from "./ZoomTooltip.module.scss";

export interface ZoomTooltipProps {
  zoomLabelPosition?: { left: string; top: string };
  className?: string;
  showIconOnly: boolean;
  toolTipText?: string;
}

export const ZoomTooltip = ({
  zoomLabelPosition,
  className,
  showIconOnly,
  toolTipText = "Click to zoom",
}: ZoomTooltipProps) => {
  return (
    <div
      className={cx(styles["zoom-label"], className)}
      style={
        zoomLabelPosition
          ? {
              transform: `translate(${zoomLabelPosition.left}, ${zoomLabelPosition.top})`,
            }
          : undefined
      }
      data-cy="zoom-label"
    >
      <div className={styles.magnify_container} data-testid="zoomtooltip:icon">
        <Magnify24PxOutlined className={styles.magnify} />
      </div>
      {!showIconOnly && (
        <div
          className={styles.zoom_tooltip_container}
          data-testid="zoomtooltip:text"
        >
          {toolTipText}
        </div>
      )}
    </div>
  );
};
